import styled from 'styled-components';

export const StyledTextArea = styled.textarea`
  width: 100%;
  height: 7.5rem;
  resize: none;
  outline: none;
  border-color: transparent;
  padding: ${({ theme }): string => theme.spacing_unit_x1};
`;
